module.exports = __webpack_public_path__ + "img/Destiny_Tools-title_white.cf85532e.png";